<template>
<div id="reset">
    <div class="container" v-if="!iAmService" style="margin-bottom: 80px;min-height: calc(100vh - 165px - 422px - 50px)">
        <div class="row">
            <br>
            <h1 style="text-align: center;" >Восстановление пароля</h1>
            <br>
            <br>
            <div class="alert alert-danger col-md-offset-20 col-md-80" role="alert" id="danger" v-if="errors" v-html="errors"></div>
            <div class="alert alert-success col-md-offset-20 col-md-80" role="alert" id="success" v-if="success" v-html="success"></div>

            <div id="form">

                <div class="form-group col-md-offset-30 col-md-60">
                    <input type="text" class="form-control" placeholder="Введите email или телефон" v-model="login">
                </div>

                <div class="form-group col-md-offset-30 col-md-60" >
                    <button type="submit" class="btn btn-primary" @click="resetPassword">Восстановить</button>
                    <button type="submit" class="btn btn-success" @click="iAmService = 1">Я Автосервис, помогите вспомнить данные</button>
                </div>

            </div>
        </div>
    </div>
    <div class="container" v-else style="margin-bottom: 80px;min-height: calc(100vh - 165px - 422px - 50px)">
        <div class="row">
            <br>
            <h1 style="text-align: center;" >Восстановление пароля</h1>
            <br>
            <br>
            <router-link tag="div" to="/cabinet/registration/" class="alert alert-danger col-md-offset-20 col-md-80" role="alert" id="danger" v-if="errors" v-html="errors"></router-link>
            <div class="alert alert-success col-md-offset-20 col-md-80" role="alert" id="success" v-if="success" v-html="success"></div>

            <div id="form">

                <div class="form-group col-md-offset-30 col-md-60">
                    <input type="text" class="form-control" placeholder="Введите email или телефон" v-model="login">
                </div>

                <div class="form-group col-md-offset-30 col-md-60" >
                    <button type="submit" class="btn btn-primary" @click="resetPasswordSto">Найти автосервис и восстановить</button>
                    <button type="submit" class="btn btn-success" @click="iAmService = 0">Я сюда попал случайно, я обычный пользователь</button>
                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'reset',
  props: ['city', 'user', 'auth', 'service', 'leads'],
  data () {
    return {
      login: null,
      errors: '',
      success: '',
      iAmService: 0
    }
  },
  watch: {
    iAmService () {
      this.errors = ''
      this.success = ''
    }
  },
  methods: {
    resetPassword () {
      var errors = []
      var $this = this
      if (!this.login) errors.push('Необходимо указать почту или телефон')
      if (errors.length === 0) {
        var formData = new FormData()
        formData.append('login', this.login)
        formData.append('uid', this.user.uid)
        axios.post('https://crm.v-avtoservice.com/list/site-reset-pass',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function (response) {
          console.log(response.data)
          if (response.data.title) $this.errors = response.data.text
          else $this.success = 'Пароль успешно восстановлен и отправлен по регистрационным данным'
        })
          .catch(function () {
          })
      }
      this.errors = errors.join('<br>')
    },
    resetPasswordSto () {
      var errors = []
      var $this = this
      if (!this.login) errors.push('Необходимо указать почту или телефон')
      if (errors.length === 0) {
        var formData = new FormData()
        formData.append('login', this.login)
        formData.append('uid', this.user.uid)
        axios.post('https://crm.v-avtoservice.com/list/site-reset-pass-sto',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function (response) {
          console.log(response.data)
          if (response.data.title) $this.errors = response.data.text
          else $this.success = 'Пароль успешно восстановлен и отправлен по регистрационным данным'
        })
          .catch(function () {
          })
      }
      this.errors = errors.join('<br>')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cabinet/reset.vue